exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*\n * Copyright (c) 2016-present, Parse, LLC\n * All rights reserved.\n *\n * This source code is licensed under the license found in the LICENSE file in\n * the root directory of this source tree.\n */\n.showMoreWrap__1Ey {\n  margin-left: 20px;\n  padding: 10px; }\n\n.pushAudienceData__3xn {\n  border: 1px solid #e7e9ed;\n  background-color: #fff; }\n\n.pushAudienceDialog__3p9 {\n  padding: 15px 30px 15px 15px;\n  text-align: right;\n  border-top: 1px solid #e7e9ed; }\n", ""]);
// Exports
exports.locals = {
	"showMoreWrap": "showMoreWrap__1Ey",
	"pushAudienceData": "pushAudienceData__3xn",
	"pushAudienceDialog": "pushAudienceDialog__3p9"
};